export const ROOT_CATEGORY_ID: string = '-1';
export const CATEGORY_DISPLAY_NAME_SPLIT_CHAR = '/';
